import React, { useEffect } from "react";

const ZenDeskBtn = (props) => {
    useEffect(() => {
        if (!window.ZendDeskInit) {
            zE("webWidget:on", "close", () => {
                zE("webWidget", "hide");
            });
            window.ZendDeskInit = true;
        }
    }, []);

    const handleClick = (e) => {
        e.preventDefault();
        if (app.tracking)
            app.tracking.sendGaClickForComponent({ selector: e.target });
        if (zE) {
            zE("webWidget", "show");
            zE("webWidget", "toggle");
        }
        return false;
    };

    return (
        <a href="#" {...props} onClick={handleClick}>
            {props.children}
        </a>
    );
};

export default ZenDeskBtn;
